"use client";
import React from "react";
import TextShimmer from "./TextShimmer";

const Spinner = ({ className = "" }) => (
  <svg className={`animate-spin h-5 w-5 text-[var(--purple)] ${className}`} fill="none" viewBox="0 0 24 24">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
  </svg>
);

const LoadingSpinner = ({ message = "Loading...", className = "" }) => {
  return (
    <div className={`flex items-center justify-center py-12 gap-3 ${className}`}>
      <Spinner />
      <TextShimmer as="span" className="text-[13px] font-medium" duration={1.5} repeatDelay={0.5}>
        {message}
      </TextShimmer>
    </div>
  );
};

export default LoadingSpinner;
export { Spinner };
